import { ReactDialogBox } from 'react-js-dialog-box';
import 'react-js-dialog-box/dist/index.css';
import "./style.scss";

const ModalBox = (props) => {
    return (
        <ReactDialogBox
            modalWidth='60%'
            headerBackgroundColor='#34aee2'
            headerTextColor='white'
            headerHeight='65'
            closeButtonColor='white'
            bodyBackgroundColor='white'
            bodyTextColor='#333'
            {...props}
        >
            {props.children}
        </ReactDialogBox>
    )
}

export { ModalBox };